import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { MapPin } from 'lucide-react';

interface PropertyMarkerProps {
  id: string | number;
  position: [number, number];
  title: string;
  price: string;
  image: string;
  onClick?: () => void;
  isHighlighted?: boolean;
}

// Criando ícone customizado para o marcador
const createCustomIcon = (price: string, isHighlighted: boolean = false) => {
  const bgColor = isHighlighted ? '#FBBF24' : '#232323';
  const arrowColor = isHighlighted ? '#FBBF24' : '#232323';
  const scaleClass = isHighlighted ? 'scale-110' : '';
  
  return L.divIcon({
    className: 'custom-marker',
    html: `
      <div class="relative flex flex-col items-center">
        <div style="background-color: ${bgColor};" class="text-white px-3 py-1.5 rounded-lg shadow-lg font-semibold text-sm whitespace-nowrap transition-all duration-200 cursor-pointer ${scaleClass}">
          ${price}
        </div>
        <div class="w-0 h-0 border-l-[6px] border-r-[6px] border-t-[8px] border-l-transparent border-r-transparent -mt-[1px] transition-all duration-200" style="border-top-color: ${arrowColor};"></div>
      </div>
    `,
    iconSize: [100, 40],
    iconAnchor: [50, 40],
    popupAnchor: [0, -40],
  });
};

const PropertyMarker: React.FC<PropertyMarkerProps> = ({
  id,
  position,
  title,
  price,
  image,
  onClick,
  isHighlighted = false,
}) => {
  const icon = createCustomIcon(price, isHighlighted);

  return (
    <Marker position={position} icon={icon} eventHandlers={{ click: onClick }}>
      <Popup>
        <div className="flex flex-col gap-2 w-48">
          <img
            src={image}
            alt={title}
            className="w-full h-32 object-cover rounded-lg"
          />
          <div className="flex flex-col gap-1">
            <h3 className="font-semibold text-sm text-neutral-dark">{title}</h3>
            <p className="font-bold text-lg text-neutral-black">{price}</p>
          </div>
          <button
            onClick={onClick}
            className="w-full bg-neutral-black text-white py-2 rounded-lg text-sm font-medium hover:opacity-90 transition-opacity"
          >
            Ver detalhes
          </button>
        </div>
      </Popup>
    </Marker>
  );
};

export default PropertyMarker;

